"use client";

import { useState, useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { Input } from "@/components/ui/Input";
import { SearchIcon } from "lucide-react";

export default function SearchBar() {
  const [searchQuery, setSearchQuery] = useState("");
  const router = useRouter();
  const searchParams = useSearchParams();

  // Update search input when URL changes
  useEffect(() => {
    const query = searchParams.get('q');
    if (query) {
      setSearchQuery(query);
    }
  }, [searchParams]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Immediate navigation without delays
      const currentPath = window.location.pathname;
      if (currentPath.startsWith('/search')) {
        // If already on search page, update the search params
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('q', searchQuery.trim());
        router.replace(newUrl.pathname + newUrl.search);
      } else {
        // Navigate to search results page with query parameter
        router.push(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      }
    }
  };

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="flex justify-end w-full align-middle my-auto">
      <form onSubmit={handleSearch} className="relative flex grow px-1">
        <div className="cursor-pointer absolute py-4 px-2 left-0 ms-2 border-r-2">
          <SearchIcon size={32} className="text-muted-foreground/55"/>
        </div>
        <Input
          id={'searchId'}
          name="search"
          value={searchQuery}
          onChange={handleSearchInputChange}
          className="peer h-16 ps-16 pe-4 ms-2"
          placeholder={'Search products, stalls, categories...'}
          type="search"
        />
      </form>
    </div>
  );
}
